import { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownOption, InputSize } from 'components/Dropdown/types';
import { useAppSelector } from 'store/hooks';
import { getAllPrinterErrors } from './slice';
import { StyledPrinterDropdown } from './styled';
import { CheckSequencePrinterType } from './types';

export const CheckSequencePrinterDropdown = ({
  printers,
  setSelectedPrinter,
  isLoading,
  defaultOption
}: CheckSequencePrinterType): React.JSX.Element => {
  const intl = useIntl();
  const printerErrors = useAppSelector(getAllPrinterErrors);
  const [printerName, setPrinterName] = useState<DropdownOption>();

  const handlePrinters = (selectedValue: DropdownOption) => {
    setPrinterName(selectedValue);
    setSelectedPrinter(selectedValue);
  };

  useEffect(() => {
    if (defaultOption) {
      setPrinterName(defaultOption);
      setSelectedPrinter(defaultOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultOption, intl]);

  return (
    <StyledPrinterDropdown
      isLoading={isLoading}
      inputId="checkSequencePrinter"
      dataTestId="checkSequencePrinter"
      label={
        <FormattedMessage
          description="Label for Printer dropdown"
          defaultMessage="Printer"
        />
      }
      placeHolder={intl.formatMessage({
        description: 'Place holder message for printer',
        defaultMessage: 'Select'
      })}
      onChange={handlePrinters}
      options={printers}
      value={printerName}
      size={InputSize.STANDARD}
      isRequired
      errorMessage={
        <FormattedMessage
          description="Label for select a Cash Company Dropdown"
          defaultMessage="Required"
        />
      }
      hasError={printerErrors.printerError}
      enableCustomValidation
    />
  );
};
